export default {
    NOTIFY_HOME_PAGE_ALARM_REFRESH: '1',
};
